// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard_dashboard__311SK","rightSide":"dashboard_rightSide__3gFrA"};